import { eventBus } from '@/helpers/_event_bus';

/**
 * パーツ編集Mixin
 */
export default {
    data() {
        return {
            // lockフラグ
            should_lock_vertical_margin: true,
            // デザイン設定は空で入れておく
            designPatternPath: '',
            desingPatterns: [],
            // eventBus用の一意ID
            uniqueId: null,
        };
    },
    created: function () {
        // イベントバスから値を受け取る
        // リンク選択や商品選択モーダルから、選択データが送信されてくる想定。
        eventBus.$on('update_' + this.componentId + '_from_event_bus', (event) => {
            this.updatePartsDataFromEventBus(event);
        });
    },
    watch: {
        'parts_data': {
            handler() {
                // lockフラグ初期化
                this.should_lock_vertical_margin = true;
            },
            immediate: true,
        },
    },
    computed: {
        // デザイン設定
        DesingPatterns: function() {
            let desingPatterns = [];
            for (const i in this.designPattern) {
                desingPatterns[i] = [];
                desingPatterns[i]['img'] = this.designPatternPath + this.designPattern[i] + '.png';
                desingPatterns[i]['desing_pattern'] = this.designPattern[i];
            }
            return desingPatterns;
        },
        // (eventBus用)コンポーネント毎の一意のキー
        // このコンポーネントが複数個呼ばれている可能性があるため一意にする
        componentId: function () {
            if (!this.uniqueId) {
                this.uniqueId = 'parts_' + Date.now();
            }
            return this.uniqueId;
        }
    },
    emits: ['open_modal_link_selecter'],
    methods: {
        // マージン上下を更新する
        updateVerticalMargin: function (updatedMargin, event) {

            // 空文字は処理しない
            if (event.target.value === '') {
                return;
            }

            let updatedMarginKey;
            let otherMarginKey;

            if (updatedMargin === 'top') {
                updatedMarginKey = 'margin_top';
                otherMarginKey = 'margin_bottom';
            } else {
                updatedMarginKey = 'margin_bottom';
                otherMarginKey = 'margin_top';
            }

            const diffVal = event.target.value - Number(this.parts_data[updatedMarginKey]);
            this.parts_data[updatedMarginKey] = event.target.value;

            // lockされているか
            if (this.should_lock_vertical_margin) {
                // もう一方に差分を反映する
                this.parts_data[otherMarginKey] = Number(this.parts_data[otherMarginKey]) + diffVal;
            }
        },
        // -------------------------
        // eventBus
        // -------------------------

        // パーツデータを更新する
        // 渡されるeventの中身: { 更新先データのindex, 更新したいデータ名, 新しいデータ }
        updatePartsDataFromEventBus: function (event) {
            // 特定index内の特定データを更新する
            this.parts_data.main[event.index][event.name] = event.newData;
        },
        // リンク選択モーダルを開く
        // components/static_html_editor/indexで呼び出されている
        // _link_selecterのopenModalLinkSelecterメソッドを
        // イベントバスを使用して発火させる。
        openLinkSelecter: function (linkUrl, index) {
            const componentId = this.componentId;
            eventBus.$emit('open_modal_link_selecter', { componentId, linkUrl, index });
        }
    }
};
